import React, { useEffect, useState } from 'react';
import { Paper, Container } from '@dev/ee-components';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { safelyDecodeBase64Url } from '@dev/ee-tools';

import { CampaignByTargetStart } from '@/store/campaigns/actions';
import { CampaignsByTargetInterface } from '@/store/campaigns/types';
import { getCampaignsStore } from '@/store/campaigns/actions';
import useMobile from '@/services/hooks/useMobile';
import { ScreenContainer, TableStyled } from './components/StyledComponents';
import { SearchComponent } from './components/SearchComponent';
import { PaginationComponent } from './components/PaginationComponent';
import { ViewCampaignsHeader } from './components/ViewCampaignsHeader';
import { TableComponent } from './components/TableComponent';
import { useQueryParams } from './hooks/useQueryParams';

const CampaignsByTarget = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { segmentname, listname } = useParams<{ segmentname: string; listname: string }>();
    const { search, perPage, page } = useQueryParams();
    const [name, setName] = useState('');
    const campaigns = useSelector(getCampaignsStore);

    useEffect(() => {
        const name = listname ? safelyDecodeBase64Url(listname) : safelyDecodeBase64Url(segmentname);
        setName(name);
        const params: CampaignsByTargetInterface = {
            name,
            nameLike: search,
            limit: perPage,
            offset: (page - 1) * perPage,
        };
        dispatch(CampaignByTargetStart(params));
    }, []);

    return (
        <Container>
            <ScreenContainer isMobile={isMobile}>
                <ViewCampaignsHeader name={name} />
                <Paper padding={{ top: 32, right: 48, bottom: 32, left: 32 }}>
                    <SearchComponent name={name} search={search} perPage={perPage} />
                    <TableStyled isMobile={isMobile}>
                        <TableComponent />
                    </TableStyled>
                    {campaigns?.byTarget && campaigns?.statusCount?.total > 0 && (
                        <PaginationComponent totalCount={campaigns?.statusCount?.total} name={name} />
                    )}
                </Paper>
            </ScreenContainer>
        </Container>
    );
};

export default CampaignsByTarget;
